window.addEventListener('load', function(){

  // do not restore scroll position
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  const scrollToLinks = document.querySelectorAll('a.scroll-to');

  scrollToLinks.forEach(link => {
    link.addEventListener('click', function(e){
        const hash = this.hash;

        if ( hash && document.querySelector(hash) ){
            e.preventDefault();

            const targetElement = document.querySelector(hash);
    
            window.scrollTo({
                top: targetElement.getBoundingClientRect().top + window.scrollY - (document.querySelector('#main-header').getBoundingClientRect().height), 
                behavior: 'smooth'
            });
    
            history.pushState({}, "", hash);
        }

    });
  });


  // scrollto onload
  const hash = window.location.hash;
  if ( hash && document.querySelector(hash) ) {
    const targetElement = document.querySelector(hash);

    window.scrollTo({
        top: targetElement.getBoundingClientRect().top + window.scrollY - (document.querySelector('#main-header').getBoundingClientRect().height), 
        behavior: 'smooth'
    });
  }

});